import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import { articles } from '@/mocks/articles';

export default function ArticleList() {
  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '鲍鱼百科' },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <div className="pt-16 md:pt-20">
        <Breadcrumb items={breadcrumbItems} />

        <section className="w-full px-4 md:px-6 py-10 md:py-16">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12 md:mb-16">
              <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
                鲍鱼百科
              </h1>
              <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
                从选购指南到烹饪技巧，从营养知识到文化故事，全面了解鲍鱼世界
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {articles.map((article) => (
                <Link
                  key={article.id}
                  to={`/articles/${article.id}`}
                  className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden transition-all duration-300 hover:border-primary-300 cursor-pointer"
                >
                  <div className="w-full aspect-[4/3] overflow-hidden bg-background-100">
                    <img
                      src={article.coverImageUrl}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="text-xs font-medium text-primary-600 bg-primary-100 px-2.5 py-1 rounded-full">
                        {article.category}
                      </span>
                      <span className="text-xs text-foreground-400">{article.date}</span>
                    </div>
                    <h2 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h2>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-foreground-400">{article.author}</span>
                      <span className="text-xs text-foreground-400">{article.readTime}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </div>

      <Footer />
      <ScrollToTop />
    </div>
  );
}